import React, { useEffect } from "react";
import propsProvider from "./CertificatesPropsProvider";
import CertificatesMainView from "./template/CertificatesMainView";
import { useIntl } from "react-intl";
import { getListCertificateByProductId } from "./CertificatesSlice";

export default function CertificatesContainer(props) {
  const { dispatch, home, certificateList } = props;
  const handleButtonClick = async () => {};
  const intl = useIntl();

  const certificatesContainerProps = {
    ...props,
    handleButtonClick,
    intl,
  };
  return (
    <CertificatesMainView {...propsProvider(certificatesContainerProps)} />
  );
}
